import AvatarCard from "@pathwright/ui/src/components/avatar/AvatarCard"
import withTranslate from "@pathwright/ui/src/components/lng/withTranslate"
import classnames from "classnames"
import styled from "styled-components"
import useCohortPermissions from "../..//cohort/useCohortPermissions"
import { REGISTRATION_ROLES } from "../constants"
import { getRegistrationRoleLabel } from "../utils"
import { useRegistrationListContext } from "./RegistrationListContainer"
import RegistrationListItemControls from "./RegistrationListItemControls"

const StyledAvatarCard = styled(AvatarCard)`
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.25);
  padding: 1.8em;
  border-radius: 1.5em;
`

const RegistrationListItem = ({ registration, className, tca }) => {
  const roleLabel = getRegistrationRoleLabel(registration.role, tca)

  const { context } = useRegistrationListContext()
  const cohortPermissions = useCohortPermissions(context)

  // Allow current user to view another user's email if current user
  // has moderator+ cohort permissions or the other user is a moderator+
  // cohort staff member.
  const showEmail =
    cohortPermissions.hasModeratorLevelAccess ||
    registration.role >= REGISTRATION_ROLES.MODERATOR.int

  // Prevent rendering the dropdown and context menue icon entirely if
  // user doesn't have permissions.
  const shouldRenderDropdown =
    showEmail || cohortPermissions.hasModeratorLevelAccess

  const renderDropdown = () => (
    <RegistrationListItemControls
      registration={registration}
      showEmail={showEmail}
    />
  )

  return (
    <StyledAvatarCard
      className={classnames("RegistrationListItem", className)}
      user={registration.user}
      meta={roleLabel}
      renderDropdown={shouldRenderDropdown && renderDropdown}
    />
  )
}

RegistrationListItem.displayName = "RegistrationListItem"

export default withTranslate(RegistrationListItem)
